(function($) {
  class SelectReplacement {
    constructor() {
      const self = this;

      this.replacements = {
        container: '<div class="fancy-select"></div>',
        view: '<div class="fancy-select__view"></div>',
        list: '<ul class="fancy-select__list"></ul>',
        listItem: '<li class="fancy-select__item"></li>'
      };

      $(document).ready(() => {
        self.init();
      });
    }

    init() {
      const self = this;
      const selects = $('select');

      selects.each((id, selectElement) => {
        const select = $(selectElement);

        select.hide();

        const container = $(this.replacements.container);
        const view = $(this.replacements.view);
        const list = $(this.replacements.list);

        const value = select.find('option:selected').text() || '---';
        const options = select.children();

        view.text(value);
        view.appendTo(container);

        let isOpen = false;

        view.click((event) => {
          event.preventDefault();

          if (isOpen) {
            list.slideUp(200);
            container.removeClass('fancy-select--open');
          }
          else {
            list.slideDown(200);
            container.addClass('fancy-select--open');
          }

          isOpen = ! isOpen;
        });

        options.each((id, option) => {
          const optionValue = $(option).attr('value');
          const optionText = $(option).text();
          const listItem = $(self.replacements.listItem);

          listItem.text(optionText);
          listItem.attr('data-value', optionValue);
          listItem.appendTo(list);

          listItem.click((event) => {
            event.preventDefault();

            select.val(optionValue);
            view.text(optionText);

            $('.facy-select__item--selected').removeClass('facy-select__item--selected');
            listItem.addClass('facy-select__item--selected');

            isOpen = false;
            list.slideUp(200);
            container.removeClass('fancy-select--open');
          });
        });

        list.appendTo(container);

        container.appendTo(select.parent());

      });
    }
  }

  const selectReplacement = new SelectReplacement();
})(jQuery);